import React from "react";

import {
  Page,
  Heading,
  ContactForm,
  Button,
  SubHeading,
  ImageBox,
  HeroBlurb,
  SocialIcons,
  Section,
  Image,
  Form,
  Text,
  Box
} from "../theme";
import { Location } from "grommet-icons";
import GoogleMapReact from "google-map-react";

import Pic from "../assets/knox.jpg";

export const GMap = ({ center, zoom, width, height, ...rest }) => {
  const defaultCenter = {
    lat: 35.962083,
    lng: -83.915554
  };
  const defaultZoom = 17;
  return (
    <Box width={width || 1} height={height || "500px"} {...rest}>
      <Box
        width={1}
        height="100%"
        position="absolute"
        bg="primaryDark"
        zIndex="2"
        mixBlendMode="color"
      />
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyDBUNNFHtcqdnXpoRJVE9kB41Gb-8m7fec" }}
        defaultCenter={center || defaultCenter}
        defaultZoom={zoom || defaultZoom}
      >
        <Box display="flex" justifyContent="center" {...defaultCenter}>
          <Location size="large" color="brand" />
          <Heading
            textAlign="center"
            fontSize={4}
            fontWeight="bold"
            color="primaryDark"
          >
            E.M.
          </Heading>
        </Box>
      </GoogleMapReact>
    </Box>
  );
};
export const ContactBlurb = props => (
  <Box {...props}>
    <SubHeading textAlign="center" fontSize={4}>
      Contact Us
    </SubHeading>

    <SocialIcons size="medium" />
  </Box>
);
export const Contact = props => {
  return (
    <Page>
      <ImageBox
        useFilter="true"
        bg="primaryDark"
        filter="saturate(.4) brightness(140%)"
        width={1}
        bgImage={Pic}
      >
        <HeroBlurb heading="Contact" image={Pic} color="white" />
      </ImageBox>
      <Section
        width={1}
        display="flex"
        alignItems="center"
        bg="secondaryLight"
        filter="saturate(0.4)"
      >
        <Box display={["none", "block"]} width={[1 / 2]}>
          <ContactBlurb width={1} />
          <ContactForm display={["none", "block"]} />
        </Box>
        <GMap width="50%" height="500px" />
      </Section>
    </Page>
  );
};
export default Contact;
